(function(){
  if(window.__nexHints)return; window.__nexHints=1;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var seen={}, busyUntil=0;
  var capped=false;
  try{ var n=+(localStorage.getItem('nex-hint-visits')||0); if(n>=4)capped=true; if(!sessionStorage.getItem('nex-hint-v')){localStorage.setItem('nex-hint-visits',n+1);sessionStorage.setItem('nex-hint-v','1');} }catch(e){}
  var ICON={
    swipe:'<span class="nh__i"><svg viewBox="0 0 44 22" fill="none" stroke="#c8ff3d" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 5L2 11l6 6M36 5l6 6-6 6"/></svg><i class="nh__dot"></i></span>',
    tap:'<span class="nh__i"><i class="nh__dot"></i></span>',
    scroll:'<span class="nh__i"><svg viewBox="0 0 22 26" fill="none" stroke="#c8ff3d" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4l7 7 7-7M4 14l7 7 7-7"/></svg></span>'
  };
  function show(el,text,type,opt){
    opt=opt||{};
    /* one cue at a time: if another is showing, wait for it and only then show this one if its spot is still on screen */
    var wait=Math.max(0,busyUntil-performance.now());
    if(wait>0){ setTimeout(function(){ if(el){ var q=el.getBoundingClientRect(); if(q.bottom<80||q.top>innerHeight-40)return; } show(el,text,type,opt); },wait+300); return; }
    busyUntil=performance.now()+(opt.life||4200)+600;
    var h=document.createElement('div'); h.className='nh nh--'+type; h.setAttribute('aria-hidden','true');
    h.innerHTML=ICON[type]+'<span>'+text+'</span>'; document.body.appendChild(h);
    var done=false, t0=performance.now(), life=opt.life||4200;
    function place(){
      var w=h.offsetWidth, x, y;
      if(opt.fixed){ x=(innerWidth-w)/2; y=innerHeight-opt.bottom-h.offsetHeight; }
      else{ var r=el.getBoundingClientRect(); x=Math.max(10,Math.min(innerWidth-w-10,r.left+r.width/2-w/2)); y=Math.min(r.bottom,innerHeight)-h.offsetHeight-16; if(y<70)y=70; }
      h.style.transform='translate('+x.toFixed(0)+'px,'+y.toFixed(0)+'px)';
    }
    function kill(){ if(done)return; done=true; h.classList.remove('is-on'); setTimeout(function(){ if(h.parentNode)h.parentNode.removeChild(h); },500); (opt.targets||[el]).forEach(function(t){ ['pointerdown','touchmove','wheel'].forEach(function(ev){ t&&t.removeEventListener&&t.removeEventListener(ev,kill); }); }); if(opt.fixed)window.removeEventListener('scroll',onS); }
    function onS(){ if(opt.stopScroll&&scrollY>opt.stopScroll)kill(); }
    if(opt.fixed)window.addEventListener('scroll',onS,{passive:true});
    if(!opt.fixed&&el){ ['pointerdown','touchmove','wheel'].forEach(function(ev){ el.addEventListener(ev,kill,{passive:true}); }); }
    function loop(){ if(done)return; place(); if(performance.now()-t0>life){kill();return;} requestAnimationFrame(loop); }
    place(); requestAnimationFrame(function(){ h.classList.add('is-on'); }); loop();
  }
  function watch(sel,text,type,delay){
    var els=[].slice.call(document.querySelectorAll(sel)); if(!els.length||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting&&!seen[sel]){ seen[sel]=1; io.disconnect(); setTimeout(function(){ show(e.target,text,type); },delay||500); } }); },{threshold:.55});
    els.forEach(function(el){ io.observe(el); });
  }
  /* the bag: a slim sticky cue at the top of the drawer, gone once you act or close the bag */
  function cartHint(){
    var root=document.querySelector('[data-cart]'); if(!root)return;
    var body=root.querySelector('[data-cart-body]'); if(!body)return;
    var c=0; try{ c=+(localStorage.getItem('nex-hint-cart')||0); }catch(e){}
    if(c>=6)return;
    var dismissed=false, counted=false, adding=false;
    function put(){
      if(dismissed||adding||!root.classList.contains('is-open'))return;
      if(body.querySelector('.nhc'))return;
      if(!body.querySelector('.cd__offers,.cd__empty'))return;
      adding=true;
      var has=!!body.querySelector('.cd__lines');
      var h=document.createElement('div'); h.className='nhc'; h.setAttribute('role','note');
      h.innerHTML='<span class="nhc__i" aria-hidden="true"><i></i></span><span class="nhc__t">'+(has?'Tap a <b>+</b> slot to build your bundle. Offers apply on their own.':'Tap a card to add it to your bag. Offers apply on their own.')+'</span><button type="button" class="nhc__x" aria-label="Got it">&times;</button>';
      body.insertBefore(h,body.firstChild);
      if(!counted){ counted=true; try{ localStorage.setItem('nex-hint-cart',c+1); }catch(e){} }
      adding=false;
    }
    function dismiss(){ dismissed=true; var h=body.querySelector('.nhc'); if(h){ h.classList.add('is-off'); setTimeout(function(){ if(h.parentNode)h.parentNode.removeChild(h); },400); } }
    body.addEventListener('click',function(e){ if(e.target.closest('.nhc__x')){ dismiss(); return; } if(e.target.closest('[data-pick],[data-add-id],[data-opts],.om__slot,.rc__add,[data-q]'))dismiss(); });
    new MutationObserver(put).observe(body,{childList:true});
    new MutationObserver(function(){ if(root.classList.contains('is-open'))put(); else if(counted)dismissed=true; }).observe(root,{attributes:true,attributeFilter:['class']});
    put();
  }
  function init(){
    if(reduce)return;
    cartHint();
    if(capped)return;
    if(document.body.classList.contains('template-index')||document.querySelector('.hero')){
      if(document.body.classList.contains('template-index'))setTimeout(function(){ if(scrollY<60)show(null,'Scroll down','scroll',{fixed:true,bottom:24,life:6500,stopScroll:80}); },1800);
    }
    watch('[data-hx]','Drag to spin','swipe');
    watch('[data-orb]','Drag to spin. Tap a color','swipe');
    watch('.pk__row','Swipe for more','swipe');
    watch('[data-rv-vp]','Swipe to read','swipe');
    watch('.wd__tiles','Tap a collection to open it','tap');
    watch('[data-wmq]','Swipe for more','swipe');
    watch('.sx__mq','Swipe for more','swipe');
    watch('[data-ox-grid]','Tap a + to start your bundle','tap');
    if(document.querySelectorAll('[data-gallery] [data-media]').length>1)watch('[data-gallery]','Swipe for more photos','swipe');
    watch('a[data-spray-link]','Tap here to leave your mark','tap');
    watch('.fq__chips','Pick a topic','tap');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init); else init();
})();